















import Vue from 'vue'

export default Vue.extend({
  name: 'SitesList',
  model: {
    prop: 'selectedSite',
    event: 'update'
  },
  data: () => {
    return {
      sites: Sites,
      selectedSite: undefined
    }
  },
  computed: {
    structuredSites () {
      const output = {} as any
      Sites.forEach(item => {
        if (!(item.label in output)) {
          output[item.label] = []
        }
        output[item.label].push(item.trunk)
      })
      return output
    }
  }
})

export const Sites = [

  { label: 'BG', trunk: 'BG-2' },
  { label: 'BG', trunk: 'BG-3' },
  { label: 'BG', trunk: 'BG-4' },
  { label: 'BG', trunk: 'BG-5' },

  { label: 'BL', trunk: 'BL-1' },
  { label: 'BL', trunk: 'BL-2' },
  { label: 'BL', trunk: 'BL-3' },
  { label: 'BL', trunk: 'BL-4' },

  { label: 'BV', trunk: 'BV-1' },
  { label: 'BV', trunk: 'BV-2' },

  { label: 'CA', trunk: 'CA-1' },
  { label: 'CA', trunk: 'CA-2' },
  { label: 'CA', trunk: 'CA-3' },
  { label: 'CA', trunk: 'CA-4' },

  { label: 'CH', trunk: 'CH-1' },
  { label: 'CH', trunk: 'CH-2' },
  { label: 'CH', trunk: 'CH-3' },
  { label: 'CH', trunk: 'CH-4' },

  { label: 'CS', trunk: 'CS-1' },
  { label: 'CS', trunk: 'CS-2' },
  { label: 'CS', trunk: 'CS-3' },
  { label: 'CS', trunk: 'CS-4' },

  { label: 'CV', trunk: 'CV-1' },
  { label: 'CV', trunk: 'CV-2' },

  { label: 'CZ', trunk: 'CZ-1' },
  { label: 'CZ', trunk: 'CZ-2' },

  { label: 'DA', trunk: 'DA-1' },
  { label: 'DA', trunk: 'DA-2' },
  { label: 'DA', trunk: 'DA-3' },
  { label: 'DA', trunk: 'DA-4' },

  { label: 'FA', trunk: 'FA-1' },
  { label: 'FA', trunk: 'FA-2' },

  { label: 'FS', trunk: 'FS-1' },
  { label: 'FS', trunk: 'FS-2' },

  { label: 'GF', trunk: 'GF-1' },
  { label: 'GF', trunk: 'GF-2' },

  { label: 'GR', trunk: 'GR-1' },
  { label: 'GR', trunk: 'GR-2' },
  { label: 'GR', trunk: 'GR-3' },
  { label: 'GR', trunk: 'GR-4' },
  { label: 'GR', trunk: 'GR-5' },
  { label: 'GR', trunk: 'GR-6' },

  { label: 'NO', trunk: 'NO-1' },
  { label: 'NO', trunk: 'NO-2' },

  { label: 'PA', trunk: 'PA-1' },
  { label: 'PA', trunk: 'PA-2' },
  { label: 'PA', trunk: 'PA-3' },
  { label: 'PA', trunk: 'PA-4' },

  { label: 'PY', trunk: 'PY-1' },
  { label: 'PY', trunk: 'PY-2' },

  { label: 'SA', trunk: 'SA-1' },
  { label: 'SA', trunk: 'SA-2' },

  { label: 'SL', trunk: 'SL-1' },
  { label: 'SL', trunk: 'SL-2' },

  { label: 'TN', trunk: 'TN-1' },
  { label: 'TN', trunk: 'TN-2' },
  { label: 'TN', trunk: 'TN-3' },
  { label: 'TN', trunk: 'TN-4' }
]
